import axios from "axios";

export const BASE_URL = process.env.REACT_APP_BASE_API_URL;
export const API_URL = removeTrailingSlash(BASE_URL!);
export const API_CLIENT_ID = process.env.REACT_APP_API_CLIENT_ID!;

async function getToken(referenceNumber?:any) {
  const queryParameters = new URLSearchParams(window.location.search);
  let body = {}
  if(referenceNumber) {
    body = {clientId: API_CLIENT_ID, guid: referenceNumber, isContract:true}
  } else {
    const guid = queryParameters.get("guid");
    body = {clientId: API_CLIENT_ID, guid: guid}
  }
  try {
    const tokenResponse: any = await axios.post(
      process.env.REACT_APP_BASE_API_URL + "generate-token",
      body,
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      }
    );

    return tokenResponse.data.token;
  } catch (error) {
    console.error(error);
  }
}

export async function getHeadersAPI(guid?:any) {
  //const token = sessionStorage.getItem("token");
  const token = await getToken(guid);
  return {
    Authorization: `Bearer ${token}`,
  };
}

function removeTrailingSlash(urlString: any) {
  const url = new URL(urlString);
  let pathname = url.pathname;
  while (pathname.endsWith("/")) {
    pathname = pathname.slice(0, -1);
  }
  const newUrl = `${url.protocol}//${url.host}${pathname}`;
  return newUrl;
}
